import React from 'react'
import PropTypes from 'prop-types'
import {
  Route,
  Switch,
  useRouteMatch,
  useLocation,
  Redirect,
} from 'react-router-dom'
import { connect } from 'react-redux'
import {
  MarketingCodeProvider,
  MembershipUpdater,
  ProductPricesGuard,
  StripePaymentIntentReset,
} from 'member-portal/components'
import { ExistingMemberApplicationAccountProvider } from 'memberships/components'
import { selectors as memberSelectors } from 'member-reducer'
import * as Views from './views'
import Layout from './Layout'
import RenewalApplicationLayout from './RenewalApplicationLayout'
import { makePath, PATH } from 'config'

const propTypes = {
  checkoutComplete: PropTypes.bool.isRequired,
}

function Routes({ checkoutComplete }) {
  const { path, url } = useRouteMatch()
  const boatPath = makePath(path, PATH.BOATS)
  const confirmationPath = makePath(url, PATH.CONFIRM_AND_LOGIN)

  return (
    <StripePaymentIntentReset>
      <Layout>
        <Switch>
          <Route exact path={confirmationPath}>
            <Views.RenewalConfirmation />
          </Route>

          <Route>
            {checkoutComplete && (
              <Redirect push to={confirmationPath} />
            )}
            <MarketingCodeProvider isRenewal>
              <ExistingMemberApplicationAccountProvider>
                <Switch>
                  <Route exact path={makePath(path, PATH.SELECTION)}>
                    <ProductPricesGuard>
                      <Views.RenewalSelectedMembershipType />
                    </ProductPricesGuard>
                  </Route>
                  <Route exact path={makePath(path, PATH.RENEWAL_QUESTIONNAIRE)}>
                    <Views.RenewalMembershipQuestionnaire />
                  </Route>
                  {/* Boat Routes */}
                  <Route exact path={makePath(boatPath, PATH.HOME_PORT_TYPE)}>
                    <Views.RenewalHomePortType />
                  </Route>
                  <Route exact path={makePath(boatPath, PATH.HOME_PORT_ADDRESS)}>
                    <Views.RenewalSearchAddress />
                  </Route>
                  <Route exact path={makePath(boatPath, PATH.HOME_PORT_LOCATION)}>
                    <Views.RenewalLocatePort />
                  </Route>
                  <Route>
                    <ApplicationStepRoutes />
                  </Route>
                </Switch>
              </ExistingMemberApplicationAccountProvider>
            </MarketingCodeProvider>
          </Route>
        </Switch>
      </Layout>
    </StripePaymentIntentReset>
  )
}

Routes.propTypes = propTypes

function mapStateToProps(state) {
  return {
    checkoutComplete: memberSelectors.checkoutComplete(state),
  }
}

export default connect(mapStateToProps)(Routes)

function ApplicationStepRoutes() {
  const { path } = useRouteMatch()
  const { pathname } = useLocation()

  return (
    <Switch>
      <Route exact path={makePath(path, PATH.ROOT)}>
        <Redirect to={makePath(pathname, PATH.CONTACT)} />
      </Route>

      <Route>
        <MembershipUpdater>
          <RenewalApplicationLayout>
            <Switch>
              <Route exact path={makePath(path, PATH.CONTACT)}>
                <Views.RenewalContactInfo />
              </Route>
              <Route exact path={makePath(path, PATH.BOATS)}>
                <Views.RenewalBoatSelection />
              </Route>
              <Route exact path={makePath(path, PATH.TERMS_AND_CONDITIONS)}>
                <Views.RenewalTermsAndConditions />
              </Route>
              <Route exact path={makePath(path, PATH.PAYMENT)}>
                <Views.RenewalPayment />
              </Route>
            </Switch>
          </RenewalApplicationLayout>
        </MembershipUpdater>
      </Route>
    </Switch>
  )
}
